import { useState, useEffect, useCallback, useRef } from 'react';

type layoutMode = 'rectangle' | 'square';
const getDimensions = (layoutMode: layoutMode, isOnboarding: boolean = false) => ({
  width: isOnboarding ? 1520 : layoutMode === 'square' ? 1080 : 1920,
  height: isOnboarding ? 855 : 1080,
});

interface ScaleOptions {
  targetId: string;
  layoutMode: layoutMode;
  isOnboarding?: boolean;
}

const useScale = ({ targetId, layoutMode, isOnboarding = false }: ScaleOptions) => {
  const [scale, setScale] = useState(1);
  const observerRef = useRef<ResizeObserver | null>(null);
  const { width, height } = getDimensions(layoutMode, isOnboarding);

  const calculateScale = useCallback((targetElement: HTMLElement) => {
    const scaleX = targetElement.clientWidth / width;
    const scaleY = targetElement.clientHeight / height;
    setScale(Math.min(scaleX, scaleY));
  }, [width, height]);

  useEffect(() => {
    let targetElement = document.getElementById(targetId);

    if (!targetElement) return;

    observerRef.current = new ResizeObserver(() => {
      if (!targetElement) return;
      calculateScale(targetElement);
    });

    observerRef.current.observe(targetElement);
    calculateScale(targetElement);

    return () => {
      observerRef.current?.disconnect();
      observerRef.current = null;
    };
  }, [targetId, calculateScale]);

  return { scale, width, height };
};

export default useScale;
